import React, { useState } from 'react';
import { renderToString } from 'react-dom/server'

import './index.css';

import { Row, Col, Container, Form, Button, Card, Accordion } from 'react-bootstrap';
import Signature from './Signature';
import ReplySignature from './ReplySignature';
import CopyButton from './CopyButton';
import ReactDOM from "react-dom";

import {createRoot} from 'react-dom/client';

function EmailSignatureGenerator({baseUrl, logoPath, logoWidth, replyLogoWidth, logoText, hasRemark, image, imageWidth, replayImage, replayImageWidth}) {

    const [remark, setRemark] = useState('');
    const [firstName, setFirstName] = useState('XXXXXX');
    const [lastName, setLastName] = useState('YYYYYY');
    const [position, setPosition] = useState('IT supervisor');
    const [positionAbr, setPositionAbr] = useState('IT Sup');
    const [country, setCountry] = useState('');
    const [mobile, setMobile] = useState('+212 6 12 34 56 78');
    const [whatsapp, setWhatsapp] = useState('+212 6 12 34 56 78');
    const [email, setEmail] = useState('xxx.yyy@netisgroup.net');
    const [skypeId, setSkypeId] = useState('xxxx_yyy_0');

    return (
        <Row>
            <Col md={5}>
                <Form>
                    <Row>
                        <Col>
                            <Form.Group controlId="remark">
                                <Form.Label>Remark</Form.Label>
                                <Form.Control type="text" placeholder="Remark" value={remark} onChange={(e) => setRemark(e.target.value) }/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="first_name">
                                <Form.Label>First name</Form.Label>
                                <Form.Control type="text" placeholder="First name" value={firstName} onChange={(e) => setFirstName(e.target.value) }/>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="last_name">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control type="text" placeholder="Nom" value={lastName} onChange={(e) => setLastName(e.target.value) } />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="8">
                            <Form.Group controlId="position">
                                <Form.Label>Position</Form.Label>
                                <Form.Control type="text" placeholder="Fonction" value={position} onChange={(e) => setPosition(e.target.value) }/>
                            </Form.Group>
                        </Col>
                        <Col  md="4">
                            <Form.Group controlId="position_abr">
                                <Form.Label>Position abbr.</Form.Label>
                                <Form.Control type="text" placeholder="Position abbr." value={positionAbr} onChange={(e) => setPositionAbr(e.target.value) } />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group controlId="country">
                        <Form.Label>Country</Form.Label>
                        <Form.Control type="text" placeholder="Not applicable for NETIS HOLDING" value={country} onChange={(e) => setCountry(e.target.value) } />
                    </Form.Group>

                    <Form.Group controlId="mobile">
                        <Form.Label>Mobile</Form.Label>
                        <Form.Control type="text" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value) } />
                    </Form.Group>

                    <Form.Group controlId="whatsapp">
                        <Form.Label>Whatsapp</Form.Label>
                        <Form.Control type="text" placeholder="Whatsapp" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value) } />
                    </Form.Group>

                    <Form.Group controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value) } />
                    </Form.Group>

                    <Form.Group controlId="skype">
                        <Form.Label>Skype ID</Form.Label>
                        <Form.Control type="text" placeholder="Skype ID" value={skypeId} onChange={(e) => setSkypeId(e.target.value) } />
                    </Form.Group>

                </Form>
            </Col>

            <Col md={7}>
                <Accordion defaultActiveKey="0">
                    <Card>
                        <Card.Header><Accordion.Toggle as={Button} variant="link" eventKey="0">Main Signature</Accordion.Toggle></Card.Header>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div style={{
                                    border: "1px dashed rgb(228, 228, 228)",
                                    padding: "10px",
                                    marginBottom: "20px",
                                    overflowX: 'auto'
                                }}>
                                    <Signature
                                        remark={remark}
                                        firstName={firstName}
                                        lastName={lastName}
                                        position={position}
                                        positionAbr={positionAbr}
                                        country={country}
                                        mobile={mobile}
                                        whatsapp={whatsapp}
                                        email={email}
                                        skypeId={skypeId}
                                        logo={logoPath }
                                        logoWidth={logoWidth}
                                        baseUrl={baseUrl}
                                        logoText={logoText}
                                        image={image}
                                        imageWidth={imageWidth}
                                    />
                                </div>
                                <div className="text-center">
                                    <CopyButton
                                        content={renderToString(<Signature
                                            remark={remark}
                                            firstName={firstName}
                                            lastName={lastName}
                                            position={position}
                                            positionAbr={positionAbr}
                                            country={country}
                                            mobile={mobile}
                                            whatsapp={whatsapp}
                                            email={email}
                                            skypeId={skypeId}
                                            logo={logoPath }
                                            logoWidth={logoWidth}
                                            baseUrl={baseUrl}
                                            logoText={logoText}
                                            image={image}
                                            imageWidth={imageWidth}
                                        />)}
                                    />
                                </div>

                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>

                    <Card>
                        <Card.Header><Accordion.Toggle as={Button} variant="link" eventKey="1">Reply Signature</Accordion.Toggle></Card.Header>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div style={{
                                    border: "1px dashed rgb(228, 228, 228)",
                                    padding: "10px",
                                    marginBottom: "20px"
                                }}>
                                    <ReplySignature
                                        remark={remark}
                                        firstName={firstName}
                                        lastName={lastName}
                                        positionAbr={positionAbr}
                                        country={country}
                                        mobile={mobile}
                                        whatsapp={whatsapp}
                                        logo={logoPath }
                                        logoWidth={logoWidth}
                                        baseUrl={baseUrl}
                                        logoText={logoText}
                                        replayImage={replayImage}
                                        replayImageWidth={replayImageWidth}
                                    />
                                </div>
                                <div className="text-center">
                                    <CopyButton
                                        content={renderToString(<ReplySignature
                                            remark={remark}
                                            firstName={firstName}
                                            lastName={lastName}
                                            positionAbr={positionAbr}
                                            country={country}
                                            mobile={mobile}
                                            whatsapp={whatsapp}
                                            logo={logoPath }
                                            logoWidth={logoWidth}
                                            baseUrl={baseUrl}
                                            logoText={logoText}
                                            replayImage={replayImage}
                                            replayImageWidth={replayImageWidth}
                                        />)}
                                    />
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </Col>
        </Row>
    );
}

let EmailSignatureGeneratorElm = document.getElementById('email-signature-generator');

if(EmailSignatureGeneratorElm) {
    const root = createRoot(EmailSignatureGeneratorElm);
    root.render(

            <EmailSignatureGenerator
                baseUrl={EmailSignatureGeneratorElm.getAttribute('data-base-url')}
                logoPath={EmailSignatureGeneratorElm.getAttribute('data-logo-path')}
                logoWidth={EmailSignatureGeneratorElm.getAttribute('data-logo-width')}
                replyLogoWidth={EmailSignatureGeneratorElm.getAttribute('data-reply-logo-width')}
                logoText={EmailSignatureGeneratorElm.getAttribute('data-logo-text')}
                hasRemark={EmailSignatureGeneratorElm.getAttribute('data-has-remark')}
                image={EmailSignatureGeneratorElm.getAttribute('data-image')}
                imageWidth={EmailSignatureGeneratorElm.getAttribute('data-image-width')}
                replayImage={EmailSignatureGeneratorElm.getAttribute('data-replay-image')}
                replayImageWidth={EmailSignatureGeneratorElm.getAttribute('data-replay-image-width')}
            />

    );
}
